import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDemo } from '../../state/DemoContext';
import Toast from '../atoms/Toast';
import './topbar.css';

const Topbar = ({ onExitDemo }) => {
  const location = useLocation();
  const history = useHistory();
  const { state } = useDemo();

  // Check if we're on the landing page
  const isLandingPage = location.pathname === '/jo-xyz-demo';

  // eslint-disable-next-line no-unused-vars
  const getPageTitle = () => {
    const path = location.pathname;
    switch (path) {
      case '/jo-xyz-demo/overview':
        return 'Overview';
      case '/jo-xyz-demo/connect':
        return 'Connect Systems';
      case '/jo-xyz-demo/marketplace':
        return 'Marketplace';
      case '/jo-xyz-demo/assets':
        return 'Asset Registry';
      case '/jo-xyz-demo/borrowing-base':
        return 'Borrowing Base';
      case '/jo-xyz-demo/agents':
        return 'AI Agents';
      case '/jo-xyz-demo/offers':
        return 'Offers';
      case '/jo-xyz-demo/accept-offer':
        return 'Accept Offer';
      case '/jo-xyz-demo/lender':
        return 'Lender POV';
      case '/jo-xyz-demo/investor':
        return 'Investor Dashboard';
      case '/jo-xyz-demo/investor/signup':
        return 'Investor Signup';
      case '/jo-xyz-demo/list-asset':
        return 'List Property';
      default:
        return 'ABL Demo';
    }
  };

  // Removed progress indicator - using dashboard links instead

  // Minimal topbar for landing page
  if (isLandingPage) {
    return (
      <header className="jo-xyz-demo-topbar jo-xyz-demo-topbar--minimal">
        <div className="jo-xyz-demo-topbar__content">
          <div className="jo-xyz-demo-topbar__left">
            <div className="jo-xyz-demo-topbar__logo" onClick={() => history.push('/jo-xyz-demo')} style={{ cursor: 'pointer' }}>
              <div className="jo-xyz-demo-logo">
                <div className="jo-xyz-demo-logo__icon">Jo</div>
                <div className="jo-xyz-demo-logo__text">
                  <span className="jo-xyz-demo-logo__title">Jo XYZ Demo</span>
                  <span className="jo-xyz-demo-logo__subtitle">Demo Asset-Backed Lending Platform</span>
                </div>
              </div>
            </div>
          </div>

          <div className="jo-xyz-demo-topbar__right">
            <div className="jo-xyz-demo-topbar__dashboards">
              <button
                className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary jo-xyz-demo-btn--sm"
                onClick={() => history.push('/jo-xyz-demo/borrower-dashboard')}
              >
                Borrower Dashboard
              </button>
              <button
                className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary jo-xyz-demo-btn--sm"
                onClick={() => history.push('/jo-xyz-demo/lender-dashboard')}
              >
                Lender Dashboard
              </button>
            </div>

            <button
              className="jo-xyz-demo-btn jo-xyz-demo-btn--warning jo-xyz-demo-btn--sm"
              onClick={() => {
                // Clear all demo data from cookies
                document.cookie = 'demo-borrower-data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                document.cookie = 'demo-lender-data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                document.cookie = 'demo-assets=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                document.cookie = 'demo-loans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                // Reload the page to reset state
                window.location.reload();
              }}
            >
              Clear Data
            </button>

            <button
              className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary jo-xyz-demo-btn--sm"
              onClick={onExitDemo}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
              Exit Demo
            </button>
          </div>
        </div>

        {state.ui.toast && (
          <Toast
            message={state.ui.toast.message}
            type={state.ui.toast.type}
            onClose={() => {}} // Will be handled by context
          />
        )}
      </header>
    );
  }

  // Full topbar for demo pages
  return (
    <header className="jo-xyz-demo-topbar">
      <div className="jo-xyz-demo-topbar__content">
        <div className="jo-xyz-demo-topbar__left">
          <div className="jo-xyz-demo-topbar__logo" onClick={() => history.push('/jo-xyz-demo')} style={{ cursor: 'pointer' }}>
            <div className="jo-xyz-demo-logo">
              <div className="jo-xyz-demo-logo__icon">Jo</div>
              <div className="jo-xyz-demo-logo__text">
                <span className="jo-xyz-demo-logo__title">Jo XYZ Demo</span>
                <span className="jo-xyz-demo-logo__subtitle">Demo Asset-Backed Lending Platform</span>
              </div>
            </div>
          </div>
        </div>

        <div className="jo-xyz-demo-topbar__right">
          <div className="jo-xyz-demo-topbar__dashboards">
            <button
              className={`jo-xyz-demo-btn jo-xyz-demo-btn--sm ${
                location.pathname === '/jo-xyz-demo/borrower-dashboard'
                  ? 'jo-xyz-demo-btn--primary'
                  : 'jo-xyz-demo-btn--secondary'
              }`}
              onClick={() => history.push('/jo-xyz-demo/borrower-dashboard')}
            >
              Borrower Dashboard
            </button>
            <button
              className={`jo-xyz-demo-btn jo-xyz-demo-btn--sm ${
                location.pathname === '/jo-xyz-demo/lender-dashboard'
                  ? 'jo-xyz-demo-btn--primary'
                  : 'jo-xyz-demo-btn--secondary'
              }`}
              onClick={() => history.push('/jo-xyz-demo/lender-dashboard')}
            >
              Lender Dashboard
            </button>
          </div>

          <button
            className="jo-xyz-demo-btn jo-xyz-demo-btn--warning jo-xyz-demo-btn--sm"
            onClick={() => {
              // Clear all demo data from cookies
              document.cookie = 'demo-borrower-data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
              document.cookie = 'demo-lender-data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
              document.cookie = 'demo-assets=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
              document.cookie = 'demo-loans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
              // Reload the page to reset state
              window.location.reload();
            }}
          >
            Clear Data
          </button>

          <button
            className="jo-xyz-demo-btn jo-xyz-demo-btn--danger jo-xyz-demo-btn--sm"
            onClick={onExitDemo}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
            Exit Demo
          </button>
        </div>
      </div>

      {state.ui.toast && (
        <Toast
          message={state.ui.toast.message}
          type={state.ui.toast.type}
          onClose={() => {}} // Will be handled by context
        />
      )}
    </header>
  );
};

export default Topbar;
